import styled from 'styled-components';
import { QUALITY_MARK_ASPECT_RATIO, breakpoints } from 'config/config';

export const StyledDeliverySection = styled.div`
  padding: 20px;
  min-height: 80px;
  background-color: ${(props) => props.theme.filterBackground};
  border-radius: 4px;
  overflow: visible;

  .delivery-entry {
    position: relative;
    margin-bottom: 15px;
    z-index: 1;

    &:first-child {
      z-index: 10;
    }

    &:nth-child(2) {
      z-index: 9;
    }

    &:nth-child(3) {
      z-index: 8;
    }

    &:nth-child(4) {
      z-index: 7;
    }

    &:nth-child(5) {
      z-index: 6;
    }
  }

  .delivery-row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 6px;
    position: relative;

    .delivery-fields {
      display: flex;
      flex: 1;
      gap: 10px;

      .address-field {
        flex: 1;
        position: relative;
        overflow: visible;
        z-index: auto;
        min-width: 0;

        .ant-form-item {
          margin-bottom: 0;
          flex-direction: column;

          .ant-form-item-label {
            text-align: left;

            > label {
              font-weight: 500;
            }
          }
        }

        .address-finder {
          .my-3 {
            margin: 0 !important;
          }

          .form-group {
            margin: 0;
          }

          .input-wrapper {
            width: 100%;
          }

          .form-control {
            width: 100% ;
            min-height: 42px;
            padding: 4px 11px;
            border: 2px solid ${(props) => props.theme.borderTable};
            border-radius: 5px;
            box-shadow: none;
            box-sizing: border-box;
          }
        }

        .ant-input-affix-wrapper {
          min-height: 42px;
          border: 2px solid ${(props) => props.theme.borderTable};
          border-radius: 5px;

          .ant-input {
            height: 100%;
          }
        }

        .data-grid,
        table {
          position: relative;
          z-index: 1000;
          background-color: ${(props) => props.theme.white};
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        }
      }

      .price-field {
        flex: 1;

        .ant-form-item {
          margin-bottom: 0;
          flex-direction: column;

          .ant-form-item-label {
            text-align: left;

            > label {
              font-weight: 500;
            }
          }
        }

        .ant-input-number {
          width: 100%;
          border: 2px solid ${(props) => props.theme.borderTable};
          border-radius: 5px;
        }
      }
    }

    .delete-button {
      border: none;
      background: transparent;
      color: ${(props) => props.theme.black};
      box-shadow: none;
      flex-shrink: 0;
      margin-top: 40px;

      &:hover {
        color: ${(props) => props.theme.black};
        background: transparent;
      }
    }
  }

  .empty-state {
    text-align: center;
    padding: 20px;
    color: ${(props) => props.theme.textSecondary};
  }

  .delivery-footer {
    display: flex;
    justify-content: flex-start;
    margin-top: 30px;

    .add-delivery-btn {
      background: transparent;
      border: 1px solid ${(props) => props.theme.black};
      border-radius: 5px;
      color: ${(props) => props.theme.black};
      box-shadow: none;

      &:hover {
        background: transparent;
        border-color: ${(props) => props.theme.black};
        color: ${(props) => props.theme.black};
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.md}px) {
    .delivery-row {
      flex-direction: column;
      align-items: stretch;

      .delivery-fields {
        flex-direction: column;
      }

      .delete-button {
        align-self: flex-end;
      }
    }
  }
`;

export const StyledDeliveryManagement = styled.div`
  .product-cell {
    display: flex;
    align-items: center;
    gap: 8px;

    .quality-marks {
      display: flex;
      gap: 4px;
      align-items: center;

      .quality-mark {
        width: 20px;
        aspect-ratio: ${QUALITY_MARK_ASPECT_RATIO};

        .ant-image {
          display: flex;
          width: 100%;
          height: 100%;

          img {
            object-fit: contain;
          }
        }
      }
    }
  }

  .section-title {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 12px;
    margin-top: 16px;
    color: ${(props) => props.theme.black};
  }

  .delivery-management-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    h3 {
      margin: 0;
      font-size: 16px;
      font-weight: 500;
    }
  }

  .products-availability-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 16px;
    padding: 12px 16px;
    background-color: ${(props) => props.theme.filterBackground};
    border: 1px solid ${(props) => props.theme.border};
    border-radius: 4px;
    font-size: 14px;

    .products-availability-title {
      font-weight: 500;
      color: ${(props) => props.theme.black};
    }

    .products-availability-item {
      display: flex;
      align-items: center;
      gap: 8px;
      color: ${(props) => props.theme.textColor};

      .quality-marks {
        display: flex;
        align-items: center;
        gap: 4px;
      }

      .quality-mark {
        height: 21px;
        width: auto;
        aspect-ratio: ${QUALITY_MARK_ASPECT_RATIO};
        margin-bottom: 5px;

        .ant-image {
          display: flex;
          width: 100%;
          height: 100%;

          img {
            height: 100%;
            object-fit: contain;
          }
        }
      }
    }
  }

  .fulfillments-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 16px;
  }

  .fulfillment-card {
    padding: 16px;
    background-color: ${(props) => props.theme.white};
    border: 1px solid ${(props) => props.theme.border};
    border-radius: 4px;

    .fulfillment-invoice-header {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 12px;
      padding-bottom: 12px;
      border-bottom: 1px solid ${(props) => props.theme.border};

      .invoice-label {
        font-weight: 500;
        color: ${(props) => props.theme.black};
      }

      .invoice-number {
        font-weight: 600;
        color: ${(props) => props.theme.textColor};
      }
    }
  }

  .fulfillment-header {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;

    .header-field {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 4px;

      .header-field-label {
        font-weight: 400;
        color: ${(props) => props.theme.stepInactiveColor};
      }

      .header-field-value {
        color: ${(props) => props.theme.darkGrayishBlue};
      }
    }
  }

  .fulfillment-fields-row {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;

    .fulfillment-address-field {
      flex: 1;
      min-width: 0;

      .my-3 {
        margin: 0 !important;
      }

      .form-group {
        margin: 0;
      }

      .form-control {
        width: 100%;
        min-height: 42px;
        padding: 4px 11px;
        border: 2px solid ${(props) => props.theme.borderTable};
        border-radius: 5px;
        box-shadow: none;
        box-sizing: border-box;
      }

      .data-grid,
      table {
        position: relative;
        z-index: 1000;
        background-color: ${(props) => props.theme.white};
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      }
    }

    .fulfillment-price-field {
      width: 200px;
      flex-shrink: 0;

      .ant-form-item {
        margin-bottom: 0;
        flex-direction: column;

        .ant-form-item-label {
          text-align: left;

          > label {
            font-weight: 500;
          }
        }
      }
    }

    .fulfillment-date-field {
      width: auto;
      flex-shrink: 0;

      .ant-picker {
        width: 100%;
      }

      .ant-form-item {
        margin-bottom: 0;
        flex-direction: column;

        .ant-form-item-label {
          text-align: left;
          white-space: nowrap;

          > label {
            font-weight: 500;
          }
        }
      }
    }
  }

  .fulfillment-body {
    .products-header {
      margin-bottom: 12px;

      strong {
        color: ${(props) => props.theme.black};
      }
    }
    
    .product-row {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 12px 0;
      background-color: ${(props) => props.theme.white};
      border-bottom: 1px solid ${(props) => props.theme.border};

      &:last-child {
        border-bottom: none;
      }

      .product-select-item {
        flex: 6;
        min-width: 0;

        .ant-form-item {
          margin-bottom: 0;
        }

        .ant-form-item-control-input {
          min-height: auto;
        }

        .ant-select {
          width: 100%;
          
          .ant-select-dropdown{
            .ant-select-item-option-selected {
              background-color: ${(props) => props.theme.border};
            }
          }
        }
      }

      .quantity-input-item {
        flex: 3;
        min-width: 0;

        .ant-form-item {
          margin-bottom: 0;
        }

        .ant-form-item-control-input {
          min-height: auto;
        }

        .ant-input-number-group-wrapper {
          width: 100%;

          .ant-input-number {
            border: 2px solid ${(props) => props.theme.borderTable};
            border-radius: 5px 0 0 5px;
            border-right: none;
          }

          .ant-input-number-group-addon {
            border: 2px solid ${(props) => props.theme.borderTable};
            border-radius: 0 5px 5px 0;
          }
        }

        .ant-input-number:not(.ant-input-number-in-form-item) {
          width: 100%;
          border: 2px solid ${(props) => props.theme.borderTable};
          border-radius: 5px;
        }
      }

      .delete-product-btn {
        flex-shrink: 0;
        align-self: center;
        border: none;
        background: transparent;
        color: ${(props) => props.theme.black};
        box-shadow: none;

        &:hover {
          background: transparent;
          color: ${(props) => props.theme.black};
        }
      }

      .product-name {
        flex: 1;
        color: ${(props) => props.theme.textColor};
      }

      .product-quantity {
        font-weight: 500;
        color: ${(props) => props.theme.textColor};
      }
    }

    .product-row-readonly {
      justify-content: space-between;

      .product-mobile-label {
        display: none;
      }

      .product-row-readonly-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
      }
    }

    .fulfillment-total-mobile {
      display: none;
    }

    .no-products {
      padding: 16px;
      text-align: center;
      color: ${(props) => props.theme.dimmedTextColor};
      background-color: ${(props) => props.theme.filterBackground};
      border: 1px dashed ${(props) => props.theme.border};
      border-radius: 4px;
      margin-bottom: 10px;
    }
  }

  .fulfillment-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
    padding-top: 12px;
    border-top: 1px solid ${(props) => props.theme.border};
  }

  .fulfillment-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .fulfillment-total-desktop {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-left: auto;
      margin-right: 8px;

      .total-label {
        color: ${(props) => props.theme.stepInactiveColor};
      }

      .total-value {
        font-weight: 500;
        color: ${(props) => props.theme.textColor};
      }
    }

    .fulfillment-actions-left {
      display: flex;
      gap: 8px;
      align-items: center;
    }

    .fulfillment-actions-right {
      display: flex;
      gap: 8px;
      align-items: center;
    }
  }

  .payment-status-tag {
    border-radius: 19px;
    border: none;
    font-weight: 400;
    padding: 7px 20px;
  }

  .add-product-btn {
    background: transparent;
    border: 1px solid ${(props) => props.theme.black};
    border-radius: 5px;
    color: ${(props) => props.theme.black};
    box-shadow: none;

    &:hover {
      background: transparent;
      border-color: ${(props) => props.theme.black};
      color: ${(props) => props.theme.black};
    }
  }

  .add-fulfillment-button {
    margin-top: 16px;
  }

  .add-fulfillment-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }

  .add-fulfillment-modal {
    background-color: ${(props) => props.theme.white};
    padding: 24px;
    border-radius: 8px;
    min-width: 400px;
    max-width: 90%;

    h4 {
      margin: 0 0 16px 0;
      font-size: 16px;
      font-weight: 500;
    }

    .modal-actions {
      display: flex;
      justify-content: flex-end;
      gap: 8px;
    }
  }

  .select-wrapper {
    width: 100%;
    margin-bottom: 16px;

    .ant-select {
      width: 100%;
    }
  }

  .product-select-item .ant-form-item-label,
  .quantity-input-item .ant-form-item-label {
    display: none;
  }


  .delete-product-btn-mobile {
    display: none;
  }

  @media only screen and (max-width: ${breakpoints.md}px) {
    .fulfillment-card .ant-form-item-label {
      padding: 0 !important;
      align-items: end !important;
      font-size: 16px;

      label {
        color: ${(props) => props.theme.stepInactiveColor} !important;
        font-size: 1rem !important;
      }
    }

    .fulfillment-card > form > .fulfillment-fields-row + div[aria-hidden="true"],
    .fulfillment-card > form > .fulfillment-header + div[aria-hidden="true"] {
      margin-top: 16px !important;
      margin-bottom: 2px !important;
    }

    .delivery-actions {
      flex-direction: column;
      align-items: stretch;

      .expected-date-picker {
        max-width: 100%;
      }
    }

    .fulfillment-header {
      flex-direction: column;
      gap: 8px;
    }

    .fulfillment-fields-row {
      flex-direction: column;

      .fulfillment-address-field .ant-form-item {
        margin-bottom: 0;
      }

      .fulfillment-price-field,
      .fulfillment-date-field {
        width: 100% !important;
        flex-shrink: 1;
      }

      .fulfillment-date-field .ant-picker {
        width: 100%;
      }

      .fulfillment-price-field .ant-input-number-group-wrapper {
        width: 100%;
      }
    }

    .fulfillment-body .products-list {
      padding-bottom: 12px;
    }

    .fulfillment-body .product-row-readonly {
      flex-direction: column;
      align-items: flex-start;
      gap: 2px;
      border-bottom: 1px solid ${(props) => props.theme.border};
      padding-top: 6px;
      padding-bottom: 6px;

      &:last-child {
        border-bottom: 1px solid ${(props) => props.theme.border};
      }

      .product-mobile-label {
        display: block;
        color: ${(props) => props.theme.stepInactiveColor};
      }

      .product-row-readonly-content {
        flex-direction: row;
        gap: 4px;
        justify-content: flex-start;
      }
    }

    .fulfillment-actions .fulfillment-total-desktop {
      display: none;
    }

    .fulfillment-body .fulfillment-total-mobile {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 2px;

      .total-label {
        color: ${(props) => props.theme.stepInactiveColor};
      }

      .total-value {
        font-weight: 400;
        color: ${(props) => props.theme.darkGrayishBlue};
      }
    }

    .fulfillment-body .product-row:not(.product-row-readonly) {
      flex-direction: column;
      align-items: stretch;
      border-bottom: none;
      gap: 0;
      padding: 0;

      .ant-form-item {
        margin-bottom: 0;
      }

      .product-select-item,
      .quantity-input-item {
        flex: none;
        width: 100%;
      }

      .product-select-item .ant-form-item-label,
      .quantity-input-item .ant-form-item-label {
        display: block;

        label {
          color: ${(props) => props.theme.stepInactiveColor} !important;
        }
      }

      .delete-product-btn {
        display: none;
      }

      .delete-product-btn-mobile {
        display: flex;
        justify-content: flex-end;
        width: 100%;
        padding: 10px 0;
        border-bottom: 1px solid ${(props) => props.theme.border};

        span {
          text-decoration: underline;
          cursor: pointer;
          color: ${(props) => props.theme.black};
        }
      }
    }


    .fulfillment-actions {
      flex-direction: row;
      overflow-x: auto;
      flex-wrap: nowrap;
      -webkit-overflow-scrolling: touch;

      &::before {
        content: '';
        margin-left: auto;
      }

      &::-webkit-scrollbar {
        height: 4px;
      }

      > * {
        flex: 0 0 auto;
      }

      .ant-btn {
        padding: 20px 5px;
      }

      .fulfillment-actions-left {
        flex-wrap: nowrap;
        margin-right: 8px;

        .ant-btn,
        .ant-tag {
          flex-shrink: 0;
          white-space: nowrap;
        }
      }

      .fulfillment-actions-right {
        flex-wrap: nowrap;

        .ant-btn,
        .ant-tag {
          flex-shrink: 0;
          white-space: nowrap;
        }
      }
    }

    .fulfillment-footer {
      flex-direction: column;
      gap: 8px;
      align-items: stretch;
    }
  }
`;

export const StyledDeliveryConditionDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0;
  padding: 10px 12px;
  background-color: ${(props) => props.theme.white};
  border: 1px solid ${(props) => props.theme.borderTable};
  border-radius: 4px;
  font-family: ${(props) => props.theme.fontText};
  font-size: 13px;

  .delivery-period {
    display: flex;
    gap: 6px;

    .delivery-period-label {
      color: ${(props) => props.theme.underTextColor};
    }

    .delivery-period-value {
      font-weight: 500;
      color: ${(props) => props.theme.textColor};
    }
  }

  .delivery-products {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .delivery-products-title {
      color: ${(props) => props.theme.underTextColor};
    }

    .delivery-products-list {
      display: flex;
      flex-direction: column;
      gap: 2px;
      margin: 0;
      padding: 0;
      list-style: none;
    }

    .delivery-product-row {
      display: flex;
      justify-content: space-between;
      gap: 12px;
      color: ${(props) => props.theme.textColor};

      .delivery-product-quantity {
        font-weight: 500;
        white-space: nowrap;
      }
    }
  }

  @media (max-width: ${breakpoints.md}px) {
    .delivery-product-row {
      flex-direction: column;
      gap: 0;
    }
  }
`;
